import { Container, Paper, styled, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SubmitButton } from "components/Admin/Form/components/SubmitButton/SubmitButton";
import { Form } from "components/Admin/Form/Form";
import { CSSProperties } from "react";
import {PasswordInput, TextInput, useNotify, useTranslate} from "react-admin";
import { useNavigate } from "react-router";
import { authService } from "services/authService";

const LoginButton = styled(SubmitButton)({
  textTransform: "none",
});

export const Login = () => {
  const t = useTranslate();

  const queryClient = useQueryClient();

  const notify = useNotify();

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (formData: any) => {
      return authService.login(formData);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["auth", "me"], () => data);
      navigate("/");
    },
    onError: (error) => {
      notify(error?.message, {type: "error" });
    },
  });

  return (
    <Box sx={styles.container}>
      <Container maxWidth="sm">
        <Paper sx={styles.formContainer} elevation={10}>
          <Typography variant="h5" component="div">
            {t("ra.auth.sign_in")}
          </Typography>
          <Typography sx={styles.descriptionText}>{t("ra.auth.auth_check_error")}</Typography>
          <Form
            onSubmit={mutation.mutate}
            error={mutation.error ?? undefined}
            isLoading={mutation.isPending}
          >
            <TextInput source="email" label="pages.login.fields.email" fullWidth size="small"/>
            <PasswordInput source="password" label="pages.login.fields.password" fullWidth size="small"/>
            <Box sx={styles.buttonsContainer}>
              <LoginButton variant="contained" type="submit">
                {t("ra.auth.sign_in")}
              </LoginButton>
            </Box>
          </Form>
        </Paper>
      </Container>
    </Box>
  );
};

const styles: { [key: string]: CSSProperties } = {
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  formContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "15px",
    boxSizing: "border-box",
    width: "100%",
  },

  descriptionText: {
    margin: "5px 0 25px 0",
  },

  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
    justifyContent: "end",
    alignItems: "center",
  },
};
